import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { InvoicesHeader, InvoicesPage } from './InvoicesByClientYardComponents';
import { InvoicesBody, InvoicesSubHeader } from './InvoicesComponents';
import { InvoiceCreateModal, InvoicePaidModal, InvoiceDeleteModal } from '../../design-system';
import { showToRoles } from '../../utils';
import { useStoreUser } from '../../context';

export const Invoices = () => {
  const { user } = useStoreUser();

  const [name, setName] = useState<string | undefined>(undefined);
  const [invoice, setInvoice] = useState<any>(null);
  const [totalCount, setTotalCount] = useState(0);
  const { clientYardId } = useParams<{ clientYardId: string }>();

  return (
    <>
      <InvoicesPage
        innerScroll
        gridTemplateRows={
          showToRoles('client', user) ? 'max-content max-content 1fr' : 'max-content 1fr'
        }
      >
        <InvoicesHeader name={name || 'Loading...'} totalCount={totalCount} />
        {showToRoles('client', user) && <InvoicesSubHeader invoice={invoice} />}
        <InvoicesBody
          clientYardId={clientYardId}
          setTotalCount={setTotalCount}
          setName={setName}
          setInvoice={setInvoice}
        />
      </InvoicesPage>
      <InvoicePaidModal />
      <InvoiceCreateModal />
      <InvoiceDeleteModal />
    </>
  );
};
